import { render, staticRenderFns } from "./ExcelCompare.vue?vue&type=template&id=6bc42a06&scoped=true&"
import script from "./ExcelCompare.vue?vue&type=script&lang=js&"
export * from "./ExcelCompare.vue?vue&type=script&lang=js&"
import style0 from "./ExcelCompare.vue?vue&type=style&index=0&id=6bc42a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc42a06",
  null
  
)

export default component.exports